import CoordinateConversion from "@arcgis/core/widgets/CoordinateConversion";
import React, { useRef, useEffect } from "react";
import './style.scss'
import CoordButton from "./CoordConverButton";

const CoordinateConversionWidget = ({view, mapEmbed=true,position="bottom-left"}) => {
  //const {view} = props;
  const coordconWidgetDiv = useRef(null);
  const coordButtonWidgetDiv=useRef(null);
  const coordConversionRef=useRef(null)

  useEffect(() => {
    if (coordconWidgetDiv.current) {
      const coordconWidget = new CoordinateConversion({
        container: coordconWidgetDiv.current,
        view: view,
        orientation: "auto",
        visible:false
      });
      coordConversionRef.current=coordconWidget
      if(mapEmbed){
      if(coordButtonWidgetDiv.current){
      view.ui.add(coordButtonWidgetDiv.current,{position: position});
      }
      view.ui.add(coordconWidget, {position: position})
    }
      return ()=>{
        coordconWidget.destroy()
      }
    }
  }, []);

  return(
    <>
    
    <div style={{ display: "flex", alignItems: "center" }} ref={coordButtonWidgetDiv}>
    <div style={{marginRight:'6px'}}>
    <CoordButton callback={
      ()=>{
        coordConversionRef.current.visible=!coordConversionRef.current.visible
        if(!coordConversionRef.current.visible){
          coordConversionRef.current.mode='live'
        }
      }} buttonState={false}></CoordButton>
    </div>
    <div ref={coordconWidgetDiv}></div>
    </div>
    </>
  )
}
export default CoordinateConversionWidget
